import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { RoutesPaths, options, verifications, customStyles } from "../Router/constant";
import { getUsers, deleteUserById } from "../Services/userService";
import ConfirmationModal from "../Components/ConfirmationModal";
import { toast } from 'react-toastify';
import Select from 'react-select';
import Skeleton from '../Components/SkeletonLoader';

export default function Usermanagement() {
  const [loading, setLoading] = useState(true);
  const [allData, setAllData] = useState({});
  const [userData, setUserData] = useState([]);
  const [offset, setOffset] = useState(1);
  const [limit] = useState(10);
  const [search, setSearch] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [isActive, setIsActive] = useState("");
  const [isVerified, setIsVerified] = useState("");
  const [confirmation, setConfirmation] = useState({ show: false, userId: null });

  useEffect(() => {
    fetchAllData();
  }, [offset, search, isActive, isVerified]);

  const fetchAllData = async () => {
    setLoading(true);
    try {
      const response = await getUsers({ offset, limit, search, isActive, isVerified });
      const users = response.data?.data?.users || [];
      const allData = response.data?.data || {};
      setUserData(users);
      setAllData(allData);
      setTotalCount(allData?.count || 0);
    } catch (error) {
      console.error("Error fetching users:", error);
      setUserData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteClick = (userId) => {
    setConfirmation({ show: true, userId });
  };

  const handleConfirmDelete = async () => {
    try {
      if (confirmation.userId) {
        const response = await deleteUserById(confirmation.userId);
        if (response.data?.status === true) {
          toast.success('User Deleted Successfully');
          fetchAllData();
          setConfirmation({ show: false, userId: null });
        } else {
          console.error("Delete failed:", response.data?.message || "Unknown error");
        }
      }
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  const handleCancelDelete = () => {
    setConfirmation({ show: false, userId: null });
  };

  const renderSkeletonRows = () => (
    [...Array(5)].map((_, index) => (
      <div className="bookingContent bookingContentData" key={index}>
        <div className="m-0 userNameWidth"><Skeleton width={100} /></div>
        <div className="m-0 userEmailWidth"><Skeleton width={150} /></div>
        <div className="m-0 userStatus"><Skeleton width={60} /></div>
        <div className="m-0 statusWidth"><Skeleton width={80} /></div>
        <div className="m-0 bookingActionButtons bookingActionwidth">
          <Skeleton width={80} height={20} />
        </div>
      </div>
    ))
  );

  const renderUserRows = () => (
    userData.map((user) => (
      <div className="bookingContent bookingContentData" key={user._id}>
        <div className="m-0 userNameWidth">{user.fullName}</div>
        <div className="m-0 userEmailWidth">{user.email}</div>
        <div className="m-0 userStatus">{user.isVerified === true ? <img className="userImageStatus" src="/assets/img/user-check.png" />
          : <img className="userImageStatus" src="/assets/img/user_uncheck.png" />}</div>
        <div className="m-0 statusWidth">
          {new Date(user.createdAt).toLocaleDateString('en-GB')}
        </div>
        <div
          className="m-0 bookingActionButtons bookingActionwidth"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            flexWrap: "wrap",
          }}
        >
          <NavLink
            to={`${RoutesPaths.USERMANAGEMENTDETAIL}/${user._id}`}
            style={{ textDecoration: "none" }}
          >
            <p
              className="m-0 actionItem"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: 0,
                cursor: "pointer",
              }}
            >
              <img src="/assets/img/view-filled.svg" alt="" />
            </p>
          </NavLink>

          <p
            className="m-0 actionItem deleteIconNew"
            onClick={() => handleDeleteClick(user._id)}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: 0,
              cursor: "pointer",
            }}
          >
            <img src="/assets/img/delete-primary.svg" alt="" />
          </p>

          <NavLink
            to={`${RoutesPaths.ADDORDER}/${user._id}`}
            style={{ textDecoration: "none" }}
          >
            <p
              className="m-0 actionItem addOrderText"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px",
                cursor: "pointer",
                margin: 0,
              }}
            >
              <button className="createOrderBtn">
                + Create order
              </button>


            </p>
          </NavLink>
        </div>
      </div>
    ))
  );

  const generatePagination = (currentPage, totalPages) => {
    const pages = [];

    if (totalPages <= 4) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 2) {
        pages.push(1, 2, '...', totalPages - 1, totalPages);
      } else if (currentPage <= 4) {
        pages.push(3, 4, '...', totalPages - 1, totalPages);
      } else if (currentPage >= totalPages - 2) {
        for (let i = totalPages - 2; i <= totalPages; i++) pages.push(i);
      } else {
        pages.push(currentPage, currentPage + 1, '...', totalPages - 1, totalPages);
      }
    }

    return pages;
  };

  return (
    <div className="container-fluid">
      <div className="row dashboardSection">
        {/* Summary cards */}
        <div className="logisticsMenu">
          <p>
            <NavLink to={RoutesPaths.DASHBOARD}>
              <img src="/assets/img/homeIcon.svg" alt="" />
            </NavLink>
          </p>
          <img src="/assets/img/chevron-right.svg" alt="" />
          <p>
            <NavLink
              to={RoutesPaths.USERMANAGEMENT}
              style={{ cursor: "pointer" }}
            >
              User management
            </NavLink>
          </p>
        </div>
        {['Total users', 'Un-verified count', 'Verified count'].map((label, idx) => {
          const count = idx === 0
            ? (allData?.unverifiedCount || 0) + (allData?.verifiedCount || 0)
            : idx === 1
              ? (allData?.unverifiedCount || 0)
              : (allData?.verifiedCount || 0);
          const imgSrc = ["/assets/img/totalBooking.png", "/assets/img/unpaid.jpg", "/assets/img/checkin.png"][idx];

          return (
            <div className="col-md-4" key={label}>
              <div className="bookingManagement">
                <div>
                  {loading ? <Skeleton width={60} /> : <h6 className="m-0">{count}</h6>}
                  {loading ? <Skeleton width={100} /> : <p className="m-0">{label}</p>}
                </div>
                <img src={imgSrc} alt=" " className="img-fluid" />
              </div>
            </div>
          );
        })}

        {/* Filters + Table */}
        <div className="col-md-12 bookingDetailsMain">
          <div className="bookingDetailsOuter">
            <div className="bookingDetailsAlign">
              <h6 className="bookingDetailsTitle p-0">User details</h6>
              <div className="bookingDetailsOuterRight">
                <div className="customSelectWrapper">
                </div>
                <div className="customSelectWrapper">
                  <Select
                    className="searchInputSelect"
                    options={verifications}
                    value={verifications.find((opt) => opt.value === isVerified)}
                    onChange={(selected) => setIsVerified(selected.value)}
                    styles={customStyles}
                  />
                </div>
                <div>
                  <input
                    type="text"
                    placeholder="Search"
                    className="searchInput"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
              </div>
            </div>

            {/* Table */}
            <div className="TableOverFlow">
              <div className="bookingContent bookingDetailsHeader">
                <div className="m-0 userNameWidth">Customer name</div>
                <div className="m-0 userEmailWidth">Customer email</div>
                <div className="m-0 userStatus">Status</div>
                <div className="m-0 statusWidth">Date</div>
                <div className="m-0 bookingActionwidth">Action</div>
              </div>

              <div>
                {loading
                  ? renderSkeletonRows()
                  : userData.length > 0
                    ? renderUserRows()
                    : <p className="noOrders">No user found</p>}
              </div>
            </div>

            {/* Pagination */}
            {/* Pagination */}
            {totalCount > 0 && Math.ceil(totalCount / limit) > 1 && (
              <div className="paginationSection">
                <p
                  onClick={() => offset > 1 && setOffset(offset - 1)}
                  style={{
                    opacity: offset > 1 ? 1 : 0.5,
                    pointerEvents: offset > 1 ? 'auto' : 'none',
                    cursor: offset > 1 ? 'pointer' : 'default'
                  }}
                >
                  <img src="/assets/img/arrow-left.svg" alt="Previous" />
                </p>

                {generatePagination(offset, Math.ceil(totalCount / limit)).map((page, idx) =>
                  page === '...' ? (
                    <p key={idx} className="ellipsis">...</p>
                  ) : (
                    <p
                      key={idx}
                      onClick={() => setOffset(page)}
                      style={{
                        fontWeight: offset === page ? 'bold' : 'normal',
                        cursor: 'pointer'
                      }}
                    >
                      {page}
                    </p>
                  )
                )}

                <p
                  onClick={() => offset < Math.ceil(totalCount / limit) && setOffset(offset + 1)}
                  style={{
                    opacity: offset < Math.ceil(totalCount / limit) ? 1 : 0.5,
                    pointerEvents: offset < Math.ceil(totalCount / limit) ? 'auto' : 'none',
                    cursor: offset < Math.ceil(totalCount / limit) ? 'pointer' : 'default'
                  }}
                >
                  <img src="/assets/img/arrow-right.svg" alt="Next" />
                </p>
              </div>
            )}



            {/* Delete Confirmation Modal */}
            <ConfirmationModal
              show={confirmation.show}
              title="Confirm delete"
              message="Do you really want to delete this user?"
              onConfirm={handleConfirmDelete}
              onCancel={handleCancelDelete}
              confirmText="Yes, delete"
              cancelText="Cancel"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
